import { render } from "./QRFileViewer.vue?vue&type=template&id=edc4e810&scoped=true"
import script from "./QRFileViewer.vue?vue&type=script&lang=js"
export * from "./QRFileViewer.vue?vue&type=script&lang=js"

import "./QRFileViewer.vue?vue&type=style&index=0&id=edc4e810&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc4e810"]])

export default __exports__